export default __webpack_public_path__ + "static/media/flyersHero.c49e3b08.jpg";